module.exports = __webpack_public_path__ + "static/media/Expertise3.fa24fd9c.png";